<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        module="basic"
        url="purchaseQualityApplications"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.no" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.refBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.statusName" clearable>
              <el-option label="草稿" value="草稿"/>
              <el-option label="采购品质审核" value="采购品质审核"/>
              <el-option label="业务接收" value="业务接收"/>
              <el-option label="技术接收" value="技术接收"/>
              <el-option label="品质接收" value="品质接收"/>
              <el-option label="品质退货" value="品质退货"/>
              <el-option label="采购退货" value="采购退货"/>
              <el-option label="生产挑选" value="生产挑选"/>
              <el-option label="品质挑选" value="品质挑选"/>
              <el-option label="采购挑选" value="采购挑选"/>
              <el-option label="生产返工" value="生产返工"/>
              <el-option label="品质返工" value="品质返工"/>
              <el-option label="采购返工" value="采购返工"/>
              <el-option label="品质其他" value="品质其他"/>
              <el-option label="仓库审核" value="仓库审核"/>
              <el-option label="复检" value="复检"/>
              <el-option label="审核" value="审核"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="供应商">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'startCreateDate', 'endCreateDate')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.submitAuth"
            type="primary"
            :disabled="scope.row.status !== 0"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
        <el-button
            v-if="limits.approveAuth"
            type="primary"
            :disabled="scope.row.status !== 0"
            @click="approveHandle(scope.row)">
          审核
        </el-button>
      </template>
    </view-table>
    <!-- 编辑 -->
    <purchase-ng-edit ref="purchaseNgEdit" @save-success="loadData"/>
    <workflow-detail ref="workflowDetail"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import PurchaseNgEdit from "./PurchaseNgEdit";
  import workflowDetail from "@/views/workFlow/WorkflowDetail.vue";

  export default {
    name: "PurchaseNgList",
    components: {
      ViewTable,
      PurchaseNgEdit,
      workflowDetail,
    },
    data() {
      return {
        limits: {
          submitAuth: this.$auth(616),
        },
        importLoading: false,
        mainBoxHeight: 0,
        data: [],
        createDateRange: [],
        filterText: "",
        filter: {
          no: "",
          refBillNo: "",
          billType: -1,
          materialNo: "",
          materialName: "",
          specification: "",
          creatorName: "",
          supplierName: "",
          status: "",
          statusName: "",
          startCreateDate: "",
          endCreateDate: "",
        },
        columnsProperty: [
          {
            key: "no",
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.purchaseNgEdit.open(params.row, true, true);
                    },
                  },
                },
                params.row.no,
              );
            },
          },
          {
            key: "statusName",
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.workflowDetail.open(params.row.pkId, 16);
                    },
                  },
                },
                params.row.statusName,
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
      };
    },
    watch: {
      "filter.startCreateDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.startCreateDate);
            this.createDateRange.push(this.filter.endCreateDate);
          }
        },
      },
    },

    methods: {
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      addEditHandle(row) {
        this.$refs.purchaseNgEdit.open(row, true, false);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        // this.$confirm("确定删除吗?", "提示", {type: "warning"})
        //     .then(() => {
        this.$http.delete("basic", "inspectionReports", row.pkId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      // })
      // .catch(() => {
      // });
      },
      submitHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "purchaseQualityApplications/submit/" + row.pkId).then(() => {
            this.loadData(1);
            this.$message.success("提交成功");
            this.selection = [];
          });
        });
      },
      approveHandle(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "purchaseQualityApplications/approve/" + row.pkId).then(() => {
            this.loadData(1);
            this.$message.success("审核成功");
            this.selection = [];
          });
        });
      },
      // checkBox
      selectHandle(selection) {
        this.selection = selection;
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      // 未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 0) {
          return {
            editAuth: false,
            delAuth: false,
          };
        } else {
          return {
            editAuth: true,
            delAuth: true,
          };
        }
      },
    },
  };
</script>
<style scoped>
</style>

<style>
</style>
